"use client";

import Box from "@mui/material/Box";
import React from "react";

import Sidebar from "./bazaar/sidebar";
import ServiceList from "./bazaar/service-list";
import CategoryList from "src/lib/components/category-section/bazaar/category-list";
import CarouselSection, { ICarouselItem } from "src/lib/components/banner-section/bazaar";

export interface VariantProps {
  carouselData?: Array<ICarouselItem>;
  categoryList?: Array<{
    id: string;
    code: string; // TODO: query top sale
    imgUrl: string;
    name: string;
  }>;
  offers: {
    left: {
      title?: { text: string; color: string };
      subTitle?: { text: string; color: string };
      bgImg?: string;
    };
    right: {
      title?: { text: string; color: string };
      subTitle?: { text: string; color: string };
      bgImg?: string;
    };
  };
}

const CategorySectionBazaar: React.FC<VariantProps> = ({
  carouselData,
  categoryList,
}: VariantProps) => {
  return (
    <Sidebar>
      <ServiceList />

      <CarouselSection carouselData={carouselData || []} linkTo={"/collection"} mobileImgOff />

      <Box mb={6} mt={3.5} className="categories">
        <CategoryList categoryList={categoryList || []} />
      </Box>
    </Sidebar>
  );
};

export default CategorySectionBazaar;
